/** Typography tokens. */
export const typography = {
  fontFamily: {
    ui: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    mono: '"JetBrains Mono", ui-monospace, "SF Mono", Menlo, monospace'
  },
  fontSize: {
    xs: 9,
    sm: 10,
    base: 11,
    md: 12,
    lg: 14,
    xl: 16
  },
  fontWeight: {
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700
  },
  letterSpacing: {
    tight: '-0.01em',
    normal: '0',
    wide: '0.04em',
    wider: '0.08em'
  }
} as const;
